import { ComparableMetric, ListedMetric, MetricMap } from '@core/models/metric.models'

export const buildTabListFromMetricMap = (metricMap: MetricMap): string[] => {
  const overview = metricMap?.metricsOverview
  const categories = metricMap?.metricCategories

  if (overview && categories?.length) {
    return [overview.key, ...categories.map((c) => c.key)]
  }
  return []
}

export const resolveMetricValue = (metric: ListedMetric | ComparableMetric, side: 'left' | 'right'): number => {
  const leftValue = (metric as ComparableMetric)?.leftMetricResult?.value ?? (metric as ListedMetric)?.homeValue
  const rightValue = (metric as ComparableMetric)?.rightMetricResult?.value ?? (metric as ListedMetric)?.awayValue

  return side === 'left' ? leftValue : rightValue
}

export const resolveMetricUnit = (metric: ListedMetric | ComparableMetric, side: 'left' | 'right'): string => {
  const leftUnit = (metric as ComparableMetric)?.leftMetricResult?.unit ?? (metric as ListedMetric)?.homeUnit
  const rightUnit = (metric as ComparableMetric)?.rightMetricResult?.unit ?? (metric as ListedMetric)?.awayUnit

  return side === 'left' ? leftUnit : rightUnit
}
